import ErrorMessageDisplayer from './ErrorMessageDisplayer';
export default {
  mounted()
  {
    ErrorMessageDisplayer(this);
  },
};
